'use strict';

var createMarkupForStyles = function createMarkupForStyles(style, spaces) {
  spaces = spaces || '';
  return Object.keys(style).map(function (property) {
    return spaces + property + ': ' + style[property] + ';';
  }).join('\n');
};

module.exports = createMarkupForStyles;


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/create-markup-for-styles.js
 ** module id = 560
 ** module chunks = 46
 **/